// src/components/Header/Header.js - Poboljšana verzija
import { useState, useEffect, useRef } from "react";
import { Navbar, Nav, Container, NavDropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaw, faPhone, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import "./Header.css";

function Header() {
  const [expanded, setExpanded] = useState(false);
  const navbarRef = useRef(null);

  // Zatvori navigaciju kada se klikne izvan nje
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navbarRef.current && !navbarRef.current.contains(event.target)) {
        setExpanded(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Keyboard navigation - zatvori sa ESC
  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === "Escape" && expanded) {
        setExpanded(false);
      }
    };

    document.addEventListener("keydown", handleEscape);
    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, [expanded]);

  // Funkcija za zatvaranje navigacije
  const closeNav = () => setExpanded(false);

  return (
    <>
      <div
        className="topbar"
        role="complementary"
        aria-label="Kontakt informacije"
      >
        <Container>
          <div className="topbar-content">
            <a
              href="tel:+385993152678"
              className="topbar-item"
              aria-label="Pozovi nas na broj 099 315 2678"
            >
              <FontAwesomeIcon icon={faPhone} aria-hidden="true" />
              <span className="topbar-text">+385 99 3152 678</span>
            </a>
            <a
              href="mailto:marina@babyzoogarden.com"
              className="topbar-item"
              aria-label="Pošalji email na marina@babyzoogarden.com"
            >
              <FontAwesomeIcon icon={faEnvelope} aria-hidden="true" />
              <span className="topbar-text">marina@babyzoogarden.com</span>
            </a>
          </div>
        </Container>
      </div>

      <Navbar
        expand="lg"
        className="header"
        expanded={expanded}
        onToggle={setExpanded}
        ref={navbarRef}
        role="navigation"
        aria-label="Glavna navigacija"
      >
        <Container>
          <Navbar.Brand
            href="#home"
            className="brand"
            aria-label="Baby Zoo Garden - Povratak na početnu stranicu"
          >
            <FontAwesomeIcon icon={faPaw} aria-hidden="true" /> Baby Zoo Garden
          </Navbar.Brand>

          <Navbar.Toggle
            aria-controls="navbar-nav"
            aria-label={
              expanded
                ? "Zatvori navigacijski meni"
                : "Otvori navigacijski meni"
            }
          />

          <Navbar.Collapse id="navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link
                href="#home"
                onClick={closeNav}
                aria-label="Idi na početnu sekciju"
              >
                Početna
              </Nav.Link>

              <NavDropdown
                title="Usluge"
                id="services-dropdown"
                className="custom-dropdown"
                aria-label="Meni usluga"
              >
                <NavDropdown.Item
                  href="#services"
                  onClick={closeNav}
                  aria-label="Slikarske radionice"
                >
                  Slikarske radionice
                </NavDropdown.Item>
                <NavDropdown.Item
                  href="#services"
                  onClick={closeNav}
                  aria-label="Kreativne radionice"
                >
                  Kreativne radionice
                </NavDropdown.Item>
                <NavDropdown.Item
                  href="#services"
                  onClick={closeNav}
                  aria-label="Facepainting usluga"
                >
                  Facepainting
                </NavDropdown.Item>
                <NavDropdown.Item
                  href="#services"
                  onClick={closeNav}
                  aria-label="Kreativna animatorica"
                >
                  Kreativna animatorica
                </NavDropdown.Item>
              </NavDropdown>

              <Nav.Link
                href="#about"
                onClick={closeNav}
                aria-label="Idi na O nama sekciju"
              >
                O nama
              </Nav.Link>

              <Nav.Link
                href="#gallery"
                onClick={closeNav}
                aria-label="Idi na Galeriju slika"
              >
                Galerija
              </Nav.Link>

              <Nav.Link
                href="#contact"
                onClick={closeNav}
                aria-label="Idi na Kontakt sekciju"
              >
                Kontakt
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
}

export default Header;
